/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * FeatureOverrideProvider — DEBUG-ONLY implementation of the model's
 * `IFeatureOverrideProvider`, injected into `FeatureActivation` at bootstrap in
 * dev-tools builds only. Delegates to `featureOverrideStorage`; it holds no
 * state of its own and never touches `localStorage` directly beyond that
 * module, keeping `FeatureActivation` unaware of any storage detail.
 */

import type { IFeatureOverrideProvider } from "../../model/interfaces";
import type { Feature } from "../../model/featureActivation";
import { getFeatureOverride } from "./featureOverrideStorage";

export class FeatureOverrideProvider implements IFeatureOverrideProvider {
  public getOverride(feature: Feature): boolean | null {
    return getFeatureOverride(feature);
  }
}
